import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { Select, Switch, Radio, Form, Row, Input } from 'antd';
import { applySnapshot, getSnapshot, isAlive } from 'mobx-state-tree';
import { keys } from 'mobx';
import styled from '@emotion/styled';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import IconSvg from '../../../../common/IconSvg';
import ShippingMethod from './ShippingMethod';
import { SettingsFormHeader } from '../../../../common/SettingsFormHeader';
import { FormItem } from '../../styled';
import { SHIPPING_TYPES } from '../../../../../constants/settings-model';
import { config } from '../../config';
import Button from '../../../../common/Button';

const RadioGroup = Radio.Group;
const { Option } = Select;

const Btn = styled.button`
  color: ${({ theme }) => theme.colors.blue};
  cursor: pointer;
  text-decoration: underline;
  border: none;
  background: transparent;
`;

@injectIntl
@Form.create()
@observer
export default class ShippingForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      policyClone: getSnapshot(props.ebayShippingPolicies),
      methodError: false,
    };
    this.validateForm = this.validateForm.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onDomesticMethodSelect = this.onDomesticMethodSelect.bind(this);
  }

  // static getDerivedStateFromProps(props, state) {
  //   if(state.policyClone === null && props.ebayShippingPolicies.name) {
  //     return {policyClone: clone(props.ebayShippingPolicies)}
  //   }
  //   return null
  // }

  componentWillUnmount() {
    const { ebayShippingPolicies } = this.props;
    if (isAlive(ebayShippingPolicies)) {
      ebayShippingPolicies.resetPolicyForm();
    }
  }

  onDomesticMethodSelect() {
    this.setState({ methodError: false });
  }

  getFieldValues() {
    const {
      form: { getFieldsValue },
      ebayShippingPolicies,
    } = this.props;
    const { ifUseInternationalShipping, ifEBayGlobalShippingProgram } = getFieldsValue([
      'ifUseInternationalShipping',
      'ifEBayGlobalShippingProgram',
    ]);
    return {
      internationalShipping:
        ifUseInternationalShipping === undefined
          ? ebayShippingPolicies.ifUseInternationalShipping
          : ifUseInternationalShipping,
      ebayGlobalShippingProgram:
        ifEBayGlobalShippingProgram === undefined
          ? ebayShippingPolicies.ifEBayGlobalShippingProgram
          : ifEBayGlobalShippingProgram,
    };
  }

  handleCancel() {
    const { ebayShippingPolicies, form } = this.props;
    const { policyClone } = this.state;
    form.resetFields();
    this.setState({ methodError: false });
    applySnapshot(ebayShippingPolicies, policyClone);
    // this.setState({
    //   policyClone: null
    // })
  }

  validateForm() {
    const {
      ebayShippingPolicies: { createPolicy, updatePolicy, domesticShippingMethods },
      form,
      isCreateAction,
      close,
    } = this.props;
    const { methodError } = this.state;
    if (!keys(domesticShippingMethods).length) {
      this.setState({ methodError: true });
    }
    form.validateFields((err, values) => {
      if (!err && !methodError) {
        if (isCreateAction) {
          createPolicy(values).then(() => close());
        } else {
          updatePolicy(values);
        }
      }
    });
  }

  render() {
    const { EBAY_GLOBAL_SHIPPING, INTERNATIONAL_SHIPPING } = SHIPPING_TYPES;
    const formItemLayout = config.editPolicyItemLayout;
    const { form, ebayShippingPolicies, intl, isCreateAction, close } = this.props;
    const { internationalShipping, ebayGlobalShippingProgram } = this.getFieldValues();
    const { getFieldDecorator } = form;
    const { methodError } = this.state;
    const {
      name,
      handlingTime,
      handlingTimeOptions,
      domesticLocationsList,
      countriesList,
      excludedDomesticLocations,
      ifUsePoBox,
      excludedCountries,
      addDomesticMethod,
      checkIfAbleToAddDomesticMethod,
      addInternationalMethod,
      checkIfAbleToAddInternationalMethod,
      normalizedDomesticMethods,
      normalizedInternationalMethods,
    } = ebayShippingPolicies;

    return (
      <Fragment>
        <FormItem
          {...formItemLayout}
          label={<FormattedMessage id="listing.setPolicyName" defaultMessage="Policy Name" />}
        >
          {getFieldDecorator('name', {
            initialValue: name,
            rules: [
              { required: true, message: intl.formatMessage({ id: 'listing.requiredName' }) },
            ],
          })(<Input type="text" />)}
        </FormItem>
        <SettingsFormHeader id="listing.shipping&Handling" defaultMessage="Shipping & Handling" />
        <FormItem
          {...formItemLayout}
          label={<FormattedMessage id="listing.handlingTime" defaultMessage="Handling Time" />}
        >
          {getFieldDecorator('handlingTime', {
            initialValue: handlingTime,
          })(
            <Select>
              {keys(handlingTimeOptions).map(time => (
                <Option key={time} value={time}>
                  {time}
                </Option>
              ))}
            </Select>,
          )}
          &nbsp;
          <FormattedMessage id="common.days" defaultMessage="Days" />
        </FormItem>
        {normalizedDomesticMethods.map(method => (
          <ShippingMethod
            title="listing.domesticShippingMethod"
            {...method}
            key={method.methodId}
            onSelect={this.onDomesticMethodSelect}
          />
        ))}
        <div style={{ marginBottom: methodError ? '0' : '2em' }}>
          <FormattedMessage id="listing.addMethod">
            {txt => (
              <Btn disabled={checkIfAbleToAddDomesticMethod()} onClick={addDomesticMethod}>
                {txt}
              </Btn>
            )}
          </FormattedMessage>
          &nbsp;
          <IconSvg size={16} type="plus-circle" />
        </div>
        {methodError && (
          <span
            style={{
              color: '#ff3f71',
              marginBottom: '1em',
              marginTop: '2px',
              display: 'inline-block',
            }}
          >
            <FormattedMessage id="listing.requiredMethod" />
          </span>
        )}
        <FormItem
          {...formItemLayout}
          label={
            <FormattedMessage
              id="listing.internationalShipping"
              defaultMessage="International Shipping"
            />
          }
        >
          {getFieldDecorator('ifUseInternationalShipping', {
            initialValue: internationalShipping,
            valuePropName: 'checked',
          })(<Switch />)}
        </FormItem>
        {internationalShipping && (
          <FormItem
            {...formItemLayout}
            label={
              <FormattedMessage
                id="listing.internationalShippingMethod"
                defaultMessage="International Shipping Method"
              />
            }
          >
            {getFieldDecorator('ifEBayGlobalShippingProgram', {
              initialValue: ebayGlobalShippingProgram,
            })(
              <RadioGroup>
                <Radio value={EBAY_GLOBAL_SHIPPING}>
                  <FormattedMessage
                    id="listing.ebayGlobalShippingProgram"
                    defaultMessage="eBay Global Shipping Program"
                  />
                </Radio>
                <Radio value={INTERNATIONAL_SHIPPING}>
                  <FormattedMessage
                    id="listing.internationalShipping"
                    defaultMessage="International Shipping"
                  />
                </Radio>
              </RadioGroup>,
            )}
          </FormItem>
        )}
        {internationalShipping && !ebayGlobalShippingProgram ? (
          <Fragment>
            {normalizedInternationalMethods.map(method => (
              <ShippingMethod
                title="listing.domesticShippingMethod"
                {...method}
                key={method.methodId}
              />
            ))}
            <div style={{ marginBottom: '2em' }} onClick={addInternationalMethod}>
              <FormattedMessage id="listing.addMethod">
                {txt => (
                  <a
                    style={{ textDecoration: 'underline' }}
                    disabled={checkIfAbleToAddInternationalMethod()}
                  >
                    {txt}
                  </a>
                )}
              </FormattedMessage>
              &nbsp;
              <IconSvg size={16} type="plus-circle" />
            </div>
          </Fragment>
        ) : null}
        <FormItem
          {...formItemLayout}
          label={
            <FormattedMessage
              id="listing.excludeDomesticLocations"
              defaultMessage="Exclude Domestic Locations"
            />
          }
        >
          {getFieldDecorator('excludedDomesticLocations', {
            initialValue: excludedDomesticLocations || [],
          })(
            <Select maxTagCount={1} mode="tags">
              {keys(domesticLocationsList).map(locationCode => (
                <Option key={locationCode} value={locationCode}>
                  {domesticLocationsList.get(locationCode)}
                </Option>
              ))}
            </Select>,
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label={
            <FormattedMessage
              id="listing.excludeShippingCountries"
              defaultMessage="Exclude Shipping Countries"
            />
          }
        >
          {getFieldDecorator('excludedCountries', { initialValue: excludedCountries || [] })(
            <Select maxTagCount={1} mode="tags">
              {keys(countriesList).map(countryCode => (
                <Option key={countryCode} value={countryCode}>
                  {countriesList.get(countryCode)}
                </Option>
              ))}
            </Select>,
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label={
            <FormattedMessage id="listing.shippingToPOBox" defaultMessage="Shipping To P.O Box" />
          }
        >
          {getFieldDecorator('ifUsePoBox', {
            id: 'ifUsePoBox',
            initialValue: ifUsePoBox,
            valuePropName: 'checked',
          })(<Switch />)}
        </FormItem>

        <Row style={{ justifyContent: 'flex-end', marginTop: '40px' }}>
          <Button
            htmlType="submit"
            type="normal"
            cssProps={{ marginRight: '5px' }}
            clickHandler={this.validateForm}
          >
            {intl.formatMessage({
              id: isCreateAction ? 'listing.createPolicy' : 'common.save',
            })}
          </Button>
          <Button type="normal" clickHandler={close}>
            {intl.formatMessage({ id: 'common.cancel' })}
          </Button>
        </Row>
      </Fragment>
    );
  }
}

ShippingForm.propTypes = {
  form: PropTypes.object,
  ebayShippingPolicies: PropTypes.object,
  intl: PropTypes.object,
  isCreateAction: PropTypes.bool,
  close: PropTypes.func,
};
